// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"55e9cc8e","141":"41d0e6d9","414":"d5df569d","415":"20f3210b","522":"4e9181b3","589":"aaa852d7","674":"42bbd44c"}[chunkId] + ".chunk.js";
};